// Utility for replaceWithVNode (changes a string to regexp, with escaped special chars : '(cat|dog)' matches that literally instead of cat OR dog)
export default function toRegExp(s, caseInsensitive) {
	if (s instanceof RegExp) {
		return s;
	}
	return new RegExp(escapeSpecialChars(s), caseInsensitive ? 'gi' : 'g');
}

export const escapeSpecialChars = s => String(s).replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');